import React, { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Loader from "./common/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./common/PrivateRoute";
import Login from "./login/Login";
import Callback from "./login/Callback";
import Dashboard from "./dashboard/Dashboard";
import VoiceSearch from "./dashboard/VoiceSearch";
import Design from "./dashboard/Design";
import ChatApp from "./dashboard/Design";
import Chat from "./dashboard/Chat";
import NotFound from "./login/NotFound";
import QRCodePage from "./dashboard/QRCode";
import Forbidden from "./login/Forbidden";
import QRLogin from "./dashboard/QRLogin";

const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        <Route path="/voice" element={<VoiceSearch/>} />
        <Route path="/chat" element={<Chat/>} />
        <Route path="/qr-login" element={<QRLogin/>} />
        <Route path="/qr" element={<QRCodePage/>} />
        <Route path="/forbidden" element={<Forbidden/>} />
        <Route path="*" element={<NotFound />} />
        </Routes>
    </Suspense>
  );
};

export default AppRoutes;
